
const contents = "query DismissablePromptsClients($promptKeys: [String!]!) {\n  viewer {\n    dismissablePrompts(promptKeys: $promptKeys) {\n      promptKey\n      isDismissed\n    }\n  }\n}\n";
const sha256Hash = "40bf998e1be4e21c7622f6f89172bff35c1597ef9833a6a07bb6fab00b8c70be";
export default { contents: contents, sha256Hash: sha256Hash };
